// 判断是否在iframe内
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

/**
 * 判断是否是供应商的域名
 * @returns 是否是供应商
 */
export const isSupplierByUrl = () => {
  const SUPPLIER_ORIGIN = process.env.SUPPLIER_ORIGIN;
  const supplierDomain = SUPPLIER_ORIGIN?.split("://")[1];
  return !!supplierDomain && window.location.hostname.includes(supplierDomain);
};


/**
 * 清洗地区名称
 * @param name 地区名称
 * @returns 清洗后的地区名称
 * @reason 因为后端返回的地区名称可能包含民族名称，在搜索的时候我为了准确性，需要清洗掉民族名称
 */
export const cleanRegionName = (name: string) => {
  let result = name;
  if(name === '新疆维吾尔自治区'){
    return name;
  }
  // 特殊处理：如果包含"族"并以"自治州"或"自治区"结尾
  if (/族.*?自治[州区]$/.test(name)) {
    // 使用更精确的匹配，去掉所有民族名称和自治区/州
    result = name.replace(
      /(朝鲜族|蒙古族|维吾尔族|哈萨克族|回族|藏族|壮族|满族|苗族|彝族|土家族|布依族|侗族|瑶族|白族|哈尼族|傣族|黎族|畲族|高山族|拉祜族|水族|东乡族|纳西族|景颇族|柯尔克孜族|土族|达斡尔族|仫佬族|羌族|布朗族|撒拉族|毛南族|仡佬族|锡伯族|阿昌族|普米族|塔吉克族|怒族|乌孜别克族|俄罗斯族|鄂温克族|德昂族|保安族|裕固族|京族|塔塔尔族|独龙族|鄂伦春族|赫哲族|门巴族|珞巴族|基诺族).*?自治[州区]$/,
      ""
    );
  } else {
    // 去掉常见的行政区划后缀
    result = name.replace(
      /(省|市|县|区|新区|开发区|高新区|自治区|自治州|特别行政区)$/,
      ""
    );
  }

  return result;
}

/**
 * 提取字符串中 {} 之间的 JSON 数据
 * @param text 包含 JSON 数据的文本
 * @returns 提取到的 JSON 字符串，如果没有找到则返回 null
 */
export const extractJsonFromText = (text: string): string | null => {
  if (!text || typeof text !== 'string') {
    return null;
  }

  // 使用正则表达式匹配 {} 之间的内容
  // 这个正则表达式会匹配从第一个 { 开始到最后一个 } 结束的内容
  const jsonMatch = text.match(/\{[\s\S]*\}/);
  
  if (jsonMatch) {
    return jsonMatch[0];
  }
  
  return null;
};

/**
 * 提取字符串中 {} 之间的 JSON 数据并解析为对象
 * @param text 包含 JSON 数据的文本
 * @returns 解析后的 JSON 对象，如果解析失败则返回 null
 */
export const extractAndParseJsonFromText = (text: string): any | null => {
  const jsonString = extractJsonFromText(text);
  
  if (!jsonString) {
    return null;
  }
  
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.warn('Failed to parse extracted JSON:', error);
    return null;
  }
};



/**
 * 替换字符串中的占位符
 * @param str 字符串
 * @param map 占位符映射
 * @returns 替换后的字符串
 */
export const replacePlaceholder = (str: string, map: Record<string, string>) => {
  Object.keys(map).forEach((key) => {
    str = str.replace(key, map[key]);
  });
  return str;
};